import FormattingTooltipLink from './FormattingTooltipLink';
export default FormattingTooltipLink;
